import { Stack } from '@mui/material';
import { VyDivider } from '../../../../../../../../../components/new-design/atoms';
import { GetExportedIntegrationsResponse, GetLightInvoicesResponse } from '@vy/api-definition';
import { ItemOf } from '@vy/utils';
import { INTEGRATION_TYPES, SYNC_JOB_STATUSES } from '@vy/integrations-types';
import { QbIntegrationStatusAccordion } from './invoice-activity-qb-sync-tab-components/QbIntegrationStatusAccordion/QbIntegrationStatusAccordion';
import { QbInvoiceDetailsAccordion } from './invoice-activity-qb-sync-tab-components/QbInvoiceDetailsAccordion/QbInvoiceDetailsAccordion';
import { QbInvoiceProductsAccordion } from './invoice-activity-qb-sync-tab-components/QbInvoiceProductsAccordion/QbInvoiceProductsAccordion';

type InvoiceActivityQbSyncTabProps = {
  invoice: ItemOf<GetLightInvoicesResponse['invoices']>;
  exportedInvoiceIntegrations: GetExportedIntegrationsResponse;
};

export const InvoiceActivityQbSyncTab: React.FC<InvoiceActivityQbSyncTabProps> = ({
  invoice,
  exportedInvoiceIntegrations,
}) => {
  const quickbooksIntegration = findQuickbooksIntegration(exportedInvoiceIntegrations);
  const isExported = quickbooksIntegration?.status === SYNC_JOB_STATUSES.COMPLETED;

  return (
    <Stack
      spacing="12px"
      sx={{
        height: 'calc(100vh - 400px)',
        overflowY: 'auto',
        scrollbarWidth: 'none',
      }}
      divider={<VyDivider />}
    >
      <QbIntegrationStatusAccordion quickbooksIntegration={quickbooksIntegration} invoice={invoice} />
      <QbInvoiceDetailsAccordion quickbooksIntegration={quickbooksIntegration} invoice={invoice} />
      <QbInvoiceProductsAccordion invoiceId={invoice.id} isExported={isExported} />
    </Stack>
  );
};

function findQuickbooksIntegration(exportedInvoiceIntegrations: GetExportedIntegrationsResponse) {
  return exportedInvoiceIntegrations.find(
    (exportedIntegration) => exportedIntegration.integration === INTEGRATION_TYPES.QUICKBOOKS,
  );
}
